import { formatDataTest } from '@/common/dataTest/DataTest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SideNavButton } from './SideNavButton';

export const ModuleButton = ({ menu, onClick, setActiveSidenavMenu, isActive }) => {
  const label = menu.shortName ?? menu.displayName;
  return (
    <SideNavButton
      dataTestId={formatDataTest('module-button', label)}
      onClick={onClick}  
      onMouseOver={() => setActiveSidenavMenu(menu)}
      icon={<FontAwesomeIcon icon={menu.icon} size="2x" />}
      label={label}
      isActive={isActive}
    />
  );
};
